import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireReactFastCompare } from '../node_modules/reactstrap/node_modules/react-fast-compare/index.js';

var reactFastCompareExports = requireReactFastCompare();
var isEqual = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompareExports);

export { isEqual as default };
